import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "question-category-header" }
const _hoisted_2 = {
  key: 0,
  class: "edit-category-box"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_4 = {
  key: 0,
  class: "category-title"
}
const _hoisted_5 = {
  key: 1,
  class: "category-title"
}
const _hoisted_6 = {
  key: 2,
  class: "category-title"
}
const _hoisted_7 = {
  class: "required-notification-trigger",
  "aria-label": "Required questions pending"
}
const _hoisted_8 = {
  width: "24",
  height: "24",
  x: "0",
  y: "0",
  viewBox: "0 0 64 64",
  style: {"enable-background":"new 0 0 512 512"},
  "xml:space": "preserve",
  class: ""
}
const _hoisted_9 = { class: "required-notification-badge" }
const _hoisted_10 = { class: "required-notification-dropdown" }
const _hoisted_11 = { class: "required-notification-list" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_confirm_modal = _resolveComponent("new-confirm-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isEditingCategory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.isEditingCategory)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editedCategoryName.name) = $event)),
                  class: "category-name-input"
                }, null, 512)), [
                  [_vModelText, _ctx.editedCategoryName.name]
                ])
              : _createCommentVNode("", true),
            (_openBlock(), _createElementBlock("svg", {
              class: "edit-category-icon",
              width: "28",
              height: "28",
              viewBox: "0 0 28 28",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args)))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("rect", {
                x: "0.5",
                y: "0.5",
                width: "27",
                height: "27",
                rx: "7.5",
                stroke: "#EDEDED"
              }, null, -1),
              _createElementVNode("path", {
                d: "M9 19L19 9M9 9L19 19",
                stroke: "#E54242",
                "stroke-width": "1.25",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ]))])),
            (_openBlock(), _createElementBlock("svg", {
              class: "edit-category-icon",
              width: "28",
              height: "28",
              viewBox: "0 0 28 28",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEditing && _ctx.handleEditing(...args)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("rect", {
                width: "28",
                height: "28",
                rx: "8",
                fill: "#0551CB"
              }, null, -1),
              _createElementVNode("path", {
                d: "M7.75 14.625L12.75 19.625L20.25 8.375",
                stroke: "white",
                "stroke-width": "1.25",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ]))]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.currentCategory === _ctx.ATTACHMENTS_ID)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Attachments"))
              : (_ctx.currentCategory === _ctx.ACTIVITY_ID)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Activities"))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.categories.filter((c) => c.id === _ctx.currentCategory)[0]?.name), 1)),
            ((_ctx.currentCategory !== _ctx.ATTACHMENTS_ID) && (_ctx.currentCategory !== _ctx.ACTIVITY_ID) )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "question-category-edit",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEditMenu && _ctx.onEditMenu(...args)))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M18.3334 8.74935V9.99935C18.3334 13.9277 18.3334 15.8919 17.113 17.1123C15.8926 18.3327 13.9285 18.3327 10.0001 18.3327C6.07171 18.3327 4.10752 18.3327 2.88714 17.1123C1.66675 15.8919 1.66675 13.9277 1.66675 9.99935C1.66675 6.07098 1.66675 4.10679 2.88714 2.8864C4.10752 1.66602 6.07171 1.66602 10.0001 1.66602H11.2501",
                      stroke: "#6B6B6B",
                      "stroke-width": "1.25",
                      "stroke-linecap": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M13.8768 2.87857L14.4175 2.33789C15.3133 1.44206 16.7657 1.44206 17.6615 2.33789C18.5574 3.23371 18.5574 4.68614 17.6615 5.58196L17.1209 6.12264M13.8768 2.87857C13.8768 2.87857 13.9444 4.02751 14.9581 5.04129C15.9719 6.05506 17.1209 6.12264 17.1209 6.12264M13.8768 2.87857L8.90606 7.84929C8.56938 8.18597 8.40105 8.35431 8.25627 8.53992C8.08549 8.75887 7.93908 8.99578 7.81961 9.24645C7.71834 9.45894 7.64306 9.68479 7.49249 10.1365L7.01043 11.5827M17.1209 6.12264L12.1501 11.0934C11.8135 11.43 11.6451 11.5984 11.4595 11.7432C11.2406 11.9139 11.0037 12.0604 10.753 12.1798C10.5405 12.2811 10.3146 12.3564 9.86294 12.5069L8.41675 12.989M8.41675 12.989L7.48099 13.3009C7.2587 13.375 7.01363 13.3172 6.84795 13.1515C6.68227 12.9858 6.62441 12.7407 6.69851 12.5184L7.01043 11.5827M8.41675 12.989L7.01043 11.5827",
                      stroke: "#6B6B6B",
                      "stroke-width": "1.25"
                    })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])),
      (Object.keys(_ctx.requiredUnansweredQuestions).length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "required-notification-wrap",
            onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isRequiredDropdownOpen = true)),
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isRequiredDropdownOpen = false))
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[9] || (_cache[9] = [
                _createStaticVNode("<g data-v-5181ffdc><path d=\"M28 57H13a7.008 7.008 0 0 1-7-7V9a7.008 7.008 0 0 1 7-7h26a7.008 7.008 0 0 1 7 7v14a1 1 0 0 1-2 0V9a5.006 5.006 0 0 0-5-5H13a5.006 5.006 0 0 0-5 5v41a5.006 5.006 0 0 0 5 5h15a1 1 0 0 1 0 2Z\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></path><path d=\"M13 16h-3a1 1 0 0 1 0-2h3a5.006 5.006 0 0 0 5-5V6a1 1 0 0 1 2 0v3a7.008 7.008 0 0 1-7 7Z\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></path><circle cx=\"14\" cy=\"24\" r=\"1\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></circle><circle cx=\"14\" cy=\"33\" r=\"1\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></circle><circle cx=\"14\" cy=\"42\" r=\"1\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></circle><path d=\"M35 25H20a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2ZM30 34H20a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2ZM27 43h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2ZM57 55H33.226a5.351 5.351 0 0 1-3.852-1.655 4.83 4.83 0 0 1-1.368-3.585 5.022 5.022 0 0 1 1.452-3.292 5.118 5.118 0 0 1 .98-.76A3.074 3.074 0 0 0 32 43.079V38.35a13.6 13.6 0 0 1 4-9.55 12.708 12.708 0 0 1 9-3.8h.024A12.984 12.984 0 0 1 58 38v5.077a3.067 3.067 0 0 0 1.558 2.623A5 5 0 0 1 57 55ZM45 27a10.718 10.718 0 0 0-7.59 3.22A11.582 11.582 0 0 0 34 38.35v4.729a5.053 5.053 0 0 1-2.537 4.346 3.1 3.1 0 0 0-.591.457A3.023 3.023 0 0 0 30 49.856a2.849 2.849 0 0 0 .817 2.109A3.34 3.34 0 0 0 33.226 53H57a2.994 2.994 0 0 0 3-3 2.979 2.979 0 0 0-1.467-2.58A5.048 5.048 0 0 1 56 43.077V38a10.984 10.984 0 0 0-10.978-11Z\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></path><path d=\"M53 39a1 1 0 0 1-1-1 6.982 6.982 0 0 0-7-7 1 1 0 0 1 0-2 8.983 8.983 0 0 1 9 9 1 1 0 0 1-1 1ZM45 62a4 4 0 0 1-4-4v-1a1 1 0 0 1 2 0v1a2 2 0 0 0 4 0v-1a1 1 0 0 1 2 0v1a4 4 0 0 1-4 4Z\" fill=\"#000000\" opacity=\"1\" data-original=\"#000000\" class=\"\" data-v-5181ffdc></path></g>", 1)
              ]))])),
              _createElementVNode("span", _hoisted_9, _toDisplayString(Object.keys(_ctx.requiredUnansweredQuestions).length), 1)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "required-notification-dropdown-title" }, "Required — not answered", -1)),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredUnansweredQuestions, (q, id) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: id,
                    class: "required-notification-item",
                    onClick: _withModifiers(($event: any) => (_ctx.onRequiredQuestionClick(id)), ["stop"])
                  }, _toDisplayString(q[0] || ''), 9, _hoisted_12))
                }), 128))
              ])
            ], 512), [
              [_vShow, _ctx.isRequiredDropdownOpen]
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_new_confirm_modal, {
      "is-visible": _ctx.isConfirmEditVisible,
      title: "Change Menu Name?",
      "reject-caption": "No, go back",
      "accept-caption": "Yes, change it",
      onOnCancel: _ctx.cancelEditingConfirmModal,
      onOnConfirm: _ctx.confirmCategoryEditModal
    }, {
      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
        _createTextVNode(" Are you sure you want to change menu name? This will change menu for all partners. ", -1)
      ]))]),
      _: 1
    }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
  ], 64))
}